import CrudCustom from '../../../libs/custom/CrudCustom';

let PenyesuaianFiskalNegatifService = new CrudCustom('/tipe-koreksi-fiskals');
export default PenyesuaianFiskalNegatifService;
